import * as emailjs from 'emailjs-com';

emailjs.init("user_4d5R86dmu6vgeJP4euxSA");

export default emailjs;


// WEBPACK FOOTER //
// ./src/utilities/emailjs.js